<template>
  <div
    id="service-request-card"
    :class="[isServiceScheduled ? 'scheduled' : 'pending', isServiceClosed ? 'closed' : '']"
    @click="launchDetail()"
  >
    <div class="avatar-container">
      <img
        v-if="service.title.includes('HVAC')"
        class="avatar-img"
        alt="avatar"
        src="@shared/assets/img/service/hvac-icon.svg"
      >
      <img
        v-else-if="service.title.includes('Plumbing')"
        class="avatar-img"
        alt="avatar"
        src="@shared/assets/img/service/plumbing-icon.svg"
      >
      <img
        v-else-if="service.title.includes('Water')"
        class="avatar-img"
        alt="avatar"
        src="@shared/assets/img/service/water-icon.png"
      >
      <img
        v-else-if="service.title.includes('Electrical')"
        class="avatar-img"
        alt="avatar"
        src="@shared/assets/img/service/electrical-icon.svg"
      >
      <img
        v-else-if="service.title.includes('Garage')"
        class="avatar-img"
        alt="avatar"
        src="@shared/assets/img/service/garage-icon.svg"
      >
      <img
        v-else-if="service.title.includes('Septic')"
        class="avatar-img"
        alt="avatar"
        src="@shared/assets/img/service/septic-icon.svg"
      >
      <img
        v-else
        class="avatar-img"
        alt="avatar"
        src="@shared/assets/img/service/other-icon.svg"
      >
    </div>
    <div>
      <div class="grid-column jc-s gap-10">
        <button
          type="button"
          class="sac__font-16 f-white med underline"
          @click="navigateToProfile"
        >
          {{ memberName }}
        </button>
        <span
          v-if="serviceItem.planName"
          class="sac-tag n-80 size-10 r-4"
        >
          {{ serviceItem.planName }}
        </span>
        <span
          v-if="isSmacAdmin"
          class="sac-tag f-green size-10 r-4"
        >
          {{ serviceItem.corpName.length > 28 ? `${serviceItem.corpName.substring(0, 28)}...` : serviceItem.corpName }}
        </span>
        <span
          v-if="activeTab === ActionStatus.Closed.toLowerCase()"
          class="sac-tag n-80 size-10 r-4 t-upper"
        >
          {{ serviceItem.type }}
        </span>
      </div>
      <div class="sac__font-18 f-white semi-bold margin-top-8">
        {{ serviceAddress }}
      </div>
      <fragment v-if="isDetailView">
        <div class="sac__font-12 n20 med margin-top-4">
          {{ serviceItem.phone }}
        </div>
        <div class="sac__font-12 n20 med">
          {{ serviceItem.email }}
        </div>
      </fragment>
      <div class="grid-column ai-c jc-s gap-16 margin-top-8">
        <span
          v-if="service.type === 'Emergency'"
          class="sac-tag red-400 size-12 r-8"
        >
          {{ service.title }}
        </span>
        <span
          v-else
          class="sac-tag n-80 size-12 r-8"
        >
          {{ service.title }}
        </span>
        <div v-if="service.externalSource?.includes('titan')" class="external-tag">
          <img
            src="@shared/assets/img/general/service-titan-logo.svg"
            alt="logo"
            class="img-size-20"
          />
          <span
            class="sac__font-14 bold no-wrap"
          >
            {{ service.externalId }} <span v-if="service.externalStatus">|</span>
          </span>
          <span
            v-if="service.externalStatus"
            class="sac__font-14 med no-wrap"
          >
            {{ service.externalStatus }}
          </span>
        </div>
      </div>
    </div>
    <div class="sac__font-14 f-white semi-bold">
      <div v-if="hvacInfo">
        <div>
          {{ hvacInfo.firstItem }}
        </div>
        <div class="margin-top-8">
          {{ hvacInfo.secondItem }}
        </div>
        <div v-if="hvacInfo.bdrRating" class="margin-top-8">
          Breakdown Risk
          <span
            v-if="hvacInfo.bdrRating === 'High'"
            class="sac-tag-outline size-10 tomato r-8"
          >
            {{ hvacInfo.bdrRating }}
          </span>
          <span
            v-else-if="hvacInfo.bdrRating === 'Medium'"
            class="sac-tag-outline size-10 sunset r-8"
          >
            {{ hvacInfo.bdrRating }}
          </span>
          <span
            v-else
            class="sac-tag-outline size-10 basil r-8"
          >
            {{ hvacInfo.bdrRating }}
          </span>
        </div>
      </div>
      <div v-else class="sac__font-14 n60">
        HVAC info not available
      </div>
      <fragment v-if="isDetailView">
        <div class="sac__font-14 f-white bold margin-top-8">
          Zones:
          <span class="sac__font-14 f-white med">
            {{ service.hvacZone }}
          </span>
        </div>
        <div class="grid-column ai-c jc-s gap-10">
          <span>
            Comfort Credit Balance:
          </span>
          <img
            src="@shared/assets/img/general/loading-mini-white.svg"
            alt="Loading"
            v-if="loadingComfortCredit"
          >
          <span v-else>${{customerBalance || '--'}}</span>
        </div>
      </fragment>
    </div>
    <button
      type="button"
      class="sac-tag n-80 size-16 r-24 center"
      @click.stop="viewAllNotes(serviceItem)"
    >
      Notes
    </button>
    <div :class="['service-tag', isServiceScheduled ? 'scheduled' : '', isServiceClosed ? 'closed' : '']">
      <div class="grid-column jc-s align-center gap-10 hide-on-hover">
        <div class="tag-image-container">
          <fragment v-if="isServiceScheduled || serviceItem.serviceStatus === ActionStatus.Completed">
            <div
              v-if="techInitials"
              class="tech-init"
            >
              {{ techInitials }}
            </div>
            <img
              v-else
              class="img-size-20"
              alt="avatar"
              src="@shared/assets/img/service/lead-profile-icon.svg"
            >
          </fragment>
          <img
            v-else-if="serviceItem.serviceStatus === ActionStatus.Cancelled"
            class="img-size-20"
            alt="Edit"
            src="@shared/assets/img/service/white-x.svg"
          >
          <img
            v-else-if="serviceItem.serviceStatus === ActionStatus.Resolved"
            class="img-size-20"
            alt="Edit"
            src="@shared/assets/img/service/white-check.svg"
          >
          <img
            v-else
            class="img-size-20"
            alt="Edit"
            src="@shared/assets/img/service/service-phone.svg"
          >
        </div>
        <div>
          <div class="sac__font-18 semi-bold">
            {{ serviceTag.status }}
          </div>
          <div class="sac__font-14 med">
            {{ serviceTag.date }}
          </div>
        </div>
      </div>
      <div v-if="isServiceScheduled" class="service-action-btns">
        <button
          type="button"
          class="action-btn"
          @click.stop="handleRequestAction('schedule-request', ActionStatus.Scheduled)"
        >
          <img
            src="@shared/assets/img/service/pencil-edit.svg"
            alt="action"
            :class="['img-size-24', isServiceScheduled ? 'invert' : '']"
          >
          <span class="sac__font-8 semi-bold">Edit</span>
        </button>
        <button
          type="button"
          class="action-btn"
          @click.stop="handleRequestAction('cancel-request', ActionStatus.Cancelled)"
        >
          <img
            src="@shared/assets/img/service/white-x.svg"
            alt="action"
            :class="['img-size-24', isServiceScheduled ? 'invert' : '']"
          >
          <span class="sac__font-8 semi-bold">Cancel</span>
        </button>
        <button
          type="button"
          class="action-btn"
          @click.stop="handleRequestAction('complete-request', ActionStatus.Completed)"
        >
          <img
            src="@shared/assets/img/service/white-check.svg"
            alt="action"
            :class="['img-size-24', isServiceScheduled ? 'invert' : '']"
          >
          <span class="sac__font-8 semi-bold">Complete</span>
        </button>
      </div>
      <div v-else class="service-action-btns">
        <button
          type="button"
          class="action-btn"
          @click.stop="handleRequestAction('decline-request', ActionStatus.Cancelled)"
        >
          <img
            src="@shared/assets/img/service/white-x.svg"
            alt="action"
            class="img-size-24"
          >
          <span class="sac__font-8 semi-bold">Cancel</span>
        </button>
        <button
          type="button"
          class="action-btn"
          @click.stop="handleRequestAction('resolve', ActionStatus.Resolved)"
        >
          <img
            src="@shared/assets/img/service/white-check.svg"
            alt="action"
            class="img-size-24"
          >
          <span class="sac__font-8 semi-bold">Resolve</span>
        </button>
        <button
          type="button"
          class="action-btn"
          @click.stop="handleRequestAction('schedule-request', ActionStatus.Scheduled)"
        >
          <img
            src="@shared/assets/img/service/calendar.svg"
            alt="action"
            :class="['img-size-24', isServiceScheduled ? 'invert' : '']"
          >
          <span class="sac__font-8 semi-bold">Schedule</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import serviceMixin from '@shared/mixins/serviceMixin';
import moment from 'moment';
import ServiceReference from '@shared/lib/constant/ServiceReference';
import ActionStatus from '@shared/lib/constant/ActionStatus';

export default {
  name: 'ServiceRequestCard',
  mixins: [serviceMixin],
  props: {
    isDetailView: Boolean,
    serviceItem: Object,
  },
  computed: {
    memberName() {
      const {
        customerName,
      } = this.serviceItem;

      return `${customerName}`;
    },
    hvacInfo() {
      const {
        profileCompletedDate,
        manufacturer,
        systemAge,
        seer,
        eer,
        acSpeed,
        systemType,
        systemLocation,
        breakdownRiskRating,
      } = this.serviceItem;
      if (!profileCompletedDate) {
        return false;
      }
      let firstItem;
      if (manufacturer) {
        firstItem = `${manufacturer}`;
      }
      if (systemAge) {
        firstItem = `${firstItem} · ${systemAge} yrs `;
      }
      if (systemLocation?.toLowerCase() === 'ground' && eer) {
        firstItem = `${firstItem} · ${eer} EER`;
      } else if (seer) {
        firstItem = `${firstItem} · ${seer} SEER`;
      }

      let secondItem;
      if (acSpeed) {
        secondItem = `${acSpeed} Speed`;
      }
      if (systemType) {
        secondItem = `${secondItem} · ${systemType} System`;
      }

      return {
        firstItem,
        secondItem,
        bdrRating: breakdownRiskRating,
      };
    },
    serviceAddress() {
      const { serviceAddress } = this.serviceItem;
      if (!serviceAddress) {
        return 'Address error';
      }
      return `${serviceAddress.address1}, ${serviceAddress.city}, ${serviceAddress.state} ${serviceAddress.zip}`;
    },
    service() {
      const {
        serviceType,
        serviceCategory,
        hvacZone,
        externalId,
        externalSource,
        externalStatus,
      } = this.serviceItem;
      return {
        title: `${serviceCategory || ''} ${serviceType || ''}`,
        type: `${serviceType || 'Service type error'}`,
        category: `${serviceCategory || 'Service category error'}`,
        hvacZone: hvacZone || 'NA',
        ext: externalId ? `${externalSource} - ${externalId}` : null,
        externalSource: externalSource?.toLowerCase(),
        externalId,
        externalStatus: this.formatExternalStatus(externalStatus),
      };
    },
    serviceTag() {
      let status = 'Pending';
      let date = null;
      let term;
      if (this.serviceItem) {
        const {
          actionStatusDate,
          serviceStatus,
          confirmedDate,
          completedDate,
          scheduleDate,
          createDate,
        } = this.serviceItem;
        if (this.scheduledStatus.includes(serviceStatus)) {
          term = 'For';
          status = ActionStatus.Scheduled;
          date = scheduleDate || confirmedDate;
        } else if (serviceStatus === ActionStatus.Completed || serviceStatus === ActionStatus.Resolved) {
          term = 'On';
          status = serviceStatus;
          date = completedDate || actionStatusDate;
        } else if (serviceStatus === ActionStatus.Cancelled) {
          term = 'On';
          status = ActionStatus.Cancelled;
          date = actionStatusDate;
        } else {
          term = 'From';
          date = actionStatusDate || createDate;
        }
      }

      return {
        status,
        date: `${term} ${moment(date).format('ll')}`,
      };
    },
    isServiceScheduled() {
      const {
        serviceStatus,
      } = this.serviceItem;
      return this.scheduledStatus.includes(serviceStatus);
    },
    isServiceClosed() {
      const {
        serviceStatus,
      } = this.serviceItem;
      return this.closedStatus.includes(serviceStatus);
    },
    techInitials() {
      const technician = this.serviceItem.technician || this.serviceItem.assignedTech;
      if (technician) {
        return technician.split(' ').map((word) => word.charAt(0)).join('').substring(0, 2);
      }
      return '';
    },
  },
  methods: {
    setServiceReference() {
      let reference;
      if (this.isServiceScheduled) {
        reference = ServiceReference.SERVICE_JOB;
      } else {
        reference = ServiceReference.SERVICE_REQUEST;
      }
      this.$store.dispatch('changeServiceValue', {
        field: 'serviceReference',
        value: reference,
      });
    },
    viewAllNotes(item) {
      this.setServiceReference();
      this.$store.dispatch('changeServiceValue', {
        field: 'serviceInfo',
        value: item,
      });
      this.toggleActionModal(true, 'view-all-notes');
    },
    launchDetail() {
      this.setServiceReference();
      this.toggleServiceBottomSheet(true, 'service-request', this.serviceItem);
    },
  },
};
</script>

<style lang="scss" scoped>
#service-request-card {
  background: $N95;
  display: grid;
  grid-template-columns: 0.5fr 4fr 2fr 1fr 2fr;
  gap: 18px;
  padding: 24px;
  border-radius: 8px;
  margin-top: 24px;
  align-items: center;
  cursor: pointer;
  &.pending {
    border-left: 8px solid $NBLUE100;
  }
  &.scheduled {
    border-left: 8px solid $FRESH;
  }
  &.closed {
    border-left: 8px solid $N40;
  }
  .tech-init {
    background-color: $WHITE;
    color: $NBLUE110;
    font-weight: 600;
    font-size: 20px;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    display: grid;
    align-items: center;
    justify-content: center;
  }
  .avatar-container {
    height: 66px;
    width: 66px;
    display: grid;
    justify-content: center;
    align-content: center;
    border-radius: 33px;
    background: $N80;
    .avatar-img {
      width: 100%;
      height: 100%;
    }
  }
  .external-tag {
    display: grid;
    grid-auto-flow:  column;
    align-items: center;
    background-color: $WHITE;
    padding: 2px 12px;
    border-radius: 8px;
    gap: 8px;
  }
  .service-tag {
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 40px;
    background-color: $NBLUE100;
    max-width: 220px;
    color: $WHITE;
    display: grid;
    justify-self: flex-end;
    &.scheduled {
      background-color: $FRESH;
      color: $BLACK;
    }
    &.closed {
      background-color: $N50;
      color: $BLACK;
      pointer-events: none;
      cursor: none;
    }
    &:hover {
      display: grid;
      justify-items: center;
      border-radius: 8px;
      .service-action-btns {
        display: grid;
      }
      .hide-on-hover {
        display: none;
      }
    }
    .tag-image-container {
      width: 40px;
      height: 40px;
      display: grid;
      justify-content: center;
      align-items: center;
      background: $BLACK;
      border-radius: 20px;
      .tag-img {
        height: 100%;
        width: 100%;
      }
    }
    .service-action-btns {
      transition: visibility 0ms, opacity 200ms linear;
      display: none;
      align-items: center;
      justify-content: center;
      grid-auto-flow: column;
      .action-btn {
        padding: 10px 12px;
        display: grid;
        font-size: 0.5rem;
        justify-items: center;
        gap: 2px;
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
